interface LoaderProps {
	size?: 'sm' | 'md' | 'lg'
	label?: string
	centered?: boolean
	className?: string
}

export default function Loader({
	size = 'md',
	label,
	centered = false,
	className = '',
}: LoaderProps) {
	const rootClass = ['ui-loader', centered ? 'ui-loader--centered' : '', className]
		.filter(Boolean)
		.join(' ')

	return (
		// Центрированный лоадер — «страница ещё грузится» (ленивые страницы, загрузка раздела): пока он в #root,
		// стартовый слой с готовой страницей не снимается (src/bootShell.ts). Вне первой загрузки метка ни на что не влияет.
		<div className={rootClass} role="status" aria-live="polite" data-boot-wait={centered ? '' : undefined}>
			<div className={`ui-loader__spinner ui-loader__spinner--${size}`} />
			{label && <p className="ui-loader__label">{label}</p>}
		</div>
	)
}
